
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,  IonItem, 
         IonLabel, IonList, IonListHeader } from
'@ionic/vue';
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
//import { Storage } from '@ionic/storage';
//import { dicOptions } from '@/composables/dicOptions';

//const store = new Storage({name: 'dicstorage'});
//const { setOptions, loadOptions } = dicOptions();

export default defineComponent({
  name: 'Tab3',
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonItem, 
    IonLabel,  IonList, IonListHeader },
    setup() {
	//loadOptions();
	const router = useRouter();
	//const { setOptions } = dicOptions();
	return { router };
    },
    async created() {
       //await store.create();
 //      await getOptions('suchmodus').then(res => this.suchmodus = res.value);
  },

    data() {
       //return { suchmodus: ''}
    },
 /*   watch: {
       suchmodus: function()  {
           setTimeout(async () => {
             await getOptions('suchmodus').then(res => this.suchmodus = res.value);
             console.log("timeout2");
           }, 2000); //https://stackoverflow.com/a/48014125
       },
    },*/
/*    ionViewWillEnter() {
	async () => { await getOptions('suchmodus').then(res => this.suchmodus = res.value);}
    console.log('Tab3 page did enter');
  },*/

//watch: {suchmodus: function() {this.suchmodus}}
})
